import { useAuth } from "../contexts/AuthContext";
import { UserRole, getRoleBasePath } from "../utils/roleUtils";

type DashboardRole = "PARTNER" | "PARTNER_ADMIN" | "SUPERVISOR";

export function useDashboardRole(defaultRole: DashboardRole = "PARTNER") {
  const { user } = useAuth();

  const currentRole = user?.role;
  const dashboardRole: DashboardRole =
    currentRole === "PARTNER" || currentRole === "PARTNER_ADMIN" || currentRole === "SUPERVISOR"
      ? currentRole
      : defaultRole;

  return {
    dashboardRole,
    dashboardBasePath: getRoleBasePath(dashboardRole as UserRole),
    isSupervisor: dashboardRole === "SUPERVISOR",
    isPartnerAdmin: dashboardRole === "PARTNER_ADMIN",
    isPartnerFamily: dashboardRole === "PARTNER" || dashboardRole === "PARTNER_ADMIN" || dashboardRole === "SUPERVISOR",
  };
}
